/**
 * API Endpoint Metadata
 * Extracted from api/v1 (portal and runtime)
 * Used for generating architecture documentation pages
 */

// Customer Portal API Endpoints
export const CUSTOMER_PORTAL_APIS = {
  resources: {
    name: 'Resources',
    description: 'Resource management operations for bots, knowledge bases, and other resources',
    basePath: 'api/v1/resources',
    endpoints: [
      { path: 'api/v1/resources', methods: ['GET', 'POST'], description: 'List or create resources' },
      { path: 'api/v1/resources/{resource_id}', methods: ['GET', 'PUT', 'DELETE'], description: 'Get, update, or delete a specific resource' },
      { path: 'api/v1/resources/{resource_id}/config', methods: ['GET', 'POST', 'PATCH'], description: 'Manage resource configuration' }
    ]
  },
  tenants: {
    name: 'Tenants',
    description: 'Multi-tenant management and tenant operations',
    basePath: 'api/v1/tenants',
    endpoints: [
      { path: 'api/v1/tenants', methods: ['GET', 'POST'], description: 'List or create tenants' },
      { path: 'api/v1/tenants/main/details', methods: ['GET'], description: 'Get main tenant details' },
      { path: 'api/v1/tenants/{tenant_id}', methods: ['GET', 'PUT', 'DELETE'], description: 'Get, update, or delete a tenant' },
      { path: 'api/v1/tenants/independent', methods: ['POST'], description: 'Create independent tenant' },
      { path: 'api/v1/tenants/discover', methods: ['GET'], description: 'Discover tenants' },
      { path: 'api/v1/tenants/{tenant_id}/app-users', methods: ['GET'], description: 'Get application users for tenant' },
      { path: 'api/v1/tenants/{tenant_id}/request-contact', methods: ['POST'], description: 'Request contact for tenant' },
      { path: 'api/v1/tenants/{tenant_id}/apply-partner', methods: ['POST'], description: 'Apply for partner status' },
      { path: 'api/v1/tenants/{tenant_id}/apply-vendor', methods: ['POST'], description: 'Apply for vendor status' },
      { path: 'api/v1/tenants/{tenant_id}/apply-testimony', methods: ['POST'], description: 'Submit testimony' }
    ]
  },
  users: {
    name: 'Users',
    description: 'User management and profile operations',
    basePath: 'api/v1/users',
    endpoints: [
      { path: 'api/v1/users', methods: ['GET', 'POST'], description: 'List or create users' },
      { path: 'api/v1/users/profile', methods: ['GET', 'PUT'], description: 'Get or update user profile' },
      { path: 'api/v1/users/{user_id}', methods: ['GET', 'PUT', 'DELETE'], description: 'Get, update, or delete a user' },
      { path: 'api/v1/users/settings', methods: ['GET', 'PUT'], description: 'Get or update user settings' },
      { path: 'api/v1/users/invite', methods: ['POST'], description: 'Invite a user' }
    ]
  },
  knowledgeManagement: {
    name: 'Knowledge Management',
    description: 'Knowledge base operations including web scraping, file uploads, and knowledge retrieval',
    basePath: 'api/v1/resources/{resource_id}/knowledge',
    endpoints: [
      { path: 'api/v1/resources/{resource_id}/knowledge/add', methods: ['POST'], description: 'Add knowledge to resource' },
      { path: 'api/v1/resources/{resource_id}/knowledge/list', methods: ['POST'], description: 'List knowledge items' },
      { path: 'api/v1/resources/{resource_id}/knowledge/{knowledge_id}', methods: ['DELETE', 'PATCH'], description: 'Delete or update knowledge item' },
      { path: 'api/v1/resources/{resource_id}/knowledge/{knowledge_id}/enable', methods: ['POST'], description: 'Enable knowledge item' },
      { path: 'api/v1/resources/{resource_id}/knowledge/{knowledge_id}/disable', methods: ['POST'], description: 'Disable knowledge item' },
      { path: 'api/v1/resources/{resource_id}/knowledge/websites', methods: ['GET', 'POST'], description: 'Manage website knowledge sources' },
      { path: 'api/v1/resources/{resource_id}/knowledge/web/scrape-history', methods: ['GET'], description: 'Get web scraping history' }
    ]
  },
  sessions: {
    name: 'Sessions',
    description: 'Session management and conversation handling',
    basePath: 'api/v1/sessions',
    endpoints: [
      { path: 'api/v1/sessions', methods: ['GET', 'POST'], description: 'List or create sessions' },
      { path: 'api/v1/sessions/{session_id}', methods: ['GET', 'PUT', 'DELETE'], description: 'Get, update, or delete a session' }
    ]
  },
  analytics: {
    name: 'Analytics',
    description: 'Analytics and metrics for resources and usage',
    basePath: 'api/v1/analytics',
    endpoints: [
      { path: 'api/v1/analytics', methods: ['GET'], description: 'Get analytics data' }
    ]
  },
  costPools: {
    name: 'Cost Pools',
    description: 'Cost pool management and billing operations',
    basePath: 'api/v1/cost-pools',
    endpoints: [
      { path: 'api/v1/cost-pools', methods: ['GET', 'POST'], description: 'List or create cost pools' },
      { path: 'api/v1/cost-pools/{cost_pool_id}', methods: ['GET', 'PUT', 'DELETE'], description: 'Get, update, or delete a cost pool' }
    ]
  },
  support: {
    name: 'Support',
    description: 'Customer support ticket management',
    basePath: 'api/v1/support',
    endpoints: [
      { path: 'api/v1/support', methods: ['GET', 'POST'], description: 'List or create support tickets' },
      { path: 'api/v1/support/{ticket_id}', methods: ['GET', 'PUT', 'DELETE'], description: 'Get, update, or delete a support ticket' }
    ]
  },
  notifications: {
    name: 'Notifications',
    description: 'Notification management and preferences',
    basePath: 'api/v1/notifications',
    endpoints: [
      { path: 'api/v1/notifications', methods: ['GET', 'POST'], description: 'List or create notifications' },
      { path: 'api/v1/notifications/{notification_id}', methods: ['GET', 'PUT', 'DELETE'], description: 'Get, update, or delete a notification' }
    ]
  },
  preferences: {
    name: 'Preferences',
    description: 'User and notification preferences',
    basePath: 'api/v1/preferences',
    endpoints: [
      { path: 'api/v1/preferences', methods: ['GET'], description: 'Get user preferences' },
      { path: 'api/v1/preferences/notifications', methods: ['GET', 'PUT'], description: 'Get or update notification preferences' },
      { path: 'api/v1/preferences/settings', methods: ['GET', 'PUT'], description: 'Get or update user settings' }
    ]
  },
  security: {
    name: 'Security',
    description: 'Security roles and permissions management',
    basePath: 'api/v1/security',
    endpoints: [
      { path: 'api/v1/roles', methods: ['GET', 'POST'], description: 'List or create security roles' },
      { path: 'api/v1/roles/{role_id}', methods: ['GET', 'PUT', 'DELETE'], description: 'Get, update, or delete a role' },
      { path: 'api/v1/role-assignments', methods: ['GET', 'POST'], description: 'List or create role assignments' }
    ]
  }
};

// Public API Endpoints
export const PUBLIC_APIS = {
  botOperations: {
    name: 'Bot Operations',
    description: 'Bot conversation and session management operations',
    basePath: 'api/v1/chatbot',
    endpoints: [
      { path: 'api/v1/chatbot/sessions', methods: ['POST'], description: 'Create a new bot session' },
      { path: 'api/v1/chatbot/generate', methods: ['POST'], description: 'Generate bot response' },
      { path: 'api/v1/chatbot/sessions/{session_id}/status', methods: ['GET'], description: 'Get response status' },
      { path: 'api/v1/chatbot/download-conversation', methods: ['POST'], description: 'Download conversation' },
      { path: 'api/v1/chatbot/delete-conversation', methods: ['POST'], description: 'Delete conversation' },
      { path: 'api/v1/chatbot/summarize-conversation', methods: ['POST'], description: 'Summarize conversation' },
      { path: 'api/v1/chatbot/config', methods: ['GET'], description: 'Get public bot configuration' }
    ]
  },
  botManagement: {
    name: 'Bot Management',
    description: 'Bot lifecycle and configuration management',
    basePath: 'api/v1/bot-management',
    endpoints: [
      { path: 'api/v1/bot-management/create', methods: ['POST'], description: 'Create a bot resource' },
      { path: 'api/v1/bot-management/list', methods: ['GET'], description: 'List bots' }
    ]
  },
  knowledgeManagement: {
    name: 'Knowledge Management',
    description: 'Public knowledge management operations',
    basePath: 'api/v1/knowledge-management',
    endpoints: [
      { path: 'api/v1/knowledge-management/search', methods: ['POST'], description: 'Search knowledge' },
      { path: 'api/v1/knowledge-management/add_knowledge', methods: ['POST'], description: 'Add knowledge' },
      { path: 'api/v1/knowledge-management/list_knowledge', methods: ['POST'], description: 'List knowledge items' },
      { path: 'api/v1/knowledge-management/delete_knowledge', methods: ['DELETE', 'POST'], description: 'Delete knowledge' },
      { path: 'api/v1/knowledge-management/add_web_knowledge', methods: ['POST'], description: 'Add web knowledge source' },
      { path: 'api/v1/knowledge-management/list_web_knowledge', methods: ['POST'], description: 'List web knowledge sources' },
      { path: 'api/v1/knowledge-management/refresh_web_knowledge', methods: ['POST'], description: 'Refresh web knowledge' },
      { path: 'api/v1/knowledge-management/add_file_knowledge', methods: ['POST'], description: 'Add file knowledge' },
      { path: 'api/v1/knowledge-management/search_knowledge', methods: ['POST'], description: 'Search knowledge items' }
    ]
  },
  knowledgeUse: {
    name: 'Knowledge Use',
    description: 'Knowledge retrieval and usage',
    basePath: 'api/v1/knowledge-use',
    endpoints: [
      { path: 'api/v1/knowledge-use/search', methods: ['POST'], description: 'Search and retrieve knowledge' }
    ]
  },
  resourceManagement: {
    name: 'Resource Management',
    description: 'Public resource management operations',
    basePath: 'api/v1/resource-management',
    endpoints: [
      { path: 'api/v1/resource-management/get-config', methods: ['GET', 'POST'], description: 'Get resource configuration' },
      { path: 'api/v1/resource-management/update-config', methods: ['POST', 'PATCH'], description: 'Update resource configuration' },
      { path: 'api/v1/resource-management/create', methods: ['POST'], description: 'Create a resource' }
    ]
  },
  agentActions: {
    name: 'Agent Actions',
    description: 'AI agent action management',
    basePath: 'api/v1/agent-actions',
    endpoints: [
      { path: 'api/v1/agent-actions/list', methods: ['GET'], description: 'Get available agent actions' },
      { path: 'api/v1/agent-actions/publish', methods: ['POST'], description: 'Publish agent action' }
    ]
  },
  agentThoughts: {
    name: 'Agent Thoughts',
    description: 'AI agent thought process and session management',
    basePath: 'api/v1/chatbot',
    endpoints: [
      { path: 'api/v1/chatbot/sessions/{session_id}/status', methods: ['GET'], description: 'Get session status' },
      { path: 'api/v1/chatbot/sessions/{session_id}/thoughts', methods: ['GET'], description: 'Get agent thoughts' },
      { path: 'api/v1/chatbot/sessions/{session_id}/clear-thoughts', methods: ['POST'], description: 'Clear agent thoughts' }
    ]
  },
  emailWebhook: {
    name: 'Email Webhook',
    description: 'Email webhook processing',
    basePath: 'api/v1/email/webhook',
    endpoints: [
      { path: 'api/v1/email/webhook', methods: ['POST'], description: 'Process email webhook' },
      { path: 'api/v1/email/webhook/test', methods: ['POST'], description: 'Test email webhook' },
      { path: 'api/v1/email/webhook/status', methods: ['GET'], description: 'Get webhook status' }
    ]
  },
  sdkServing: {
    name: 'SDK Serving',
    description: 'SDK file and configuration serving',
    basePath: 'api/v1/sdk',
    endpoints: [
      { path: 'api/v1/sdk', methods: ['GET'], description: 'Get SDK information' },
      { path: 'api/v1/sdk/loader', methods: ['GET'], description: 'Get SDK loader' },
      { path: 'api/v1/sdk/{resource_type}', methods: ['GET'], description: 'Get SDK for resource type' },
      { path: 'api/v1/sdk/bots/{bot_id}', methods: ['GET'], description: 'Get bot SDK widget (Web Component)' },
      { path: 'api/v1/sdk/bot/{file}', methods: ['GET'], description: 'Get SDK file (legacy)' },
      { path: 'api/v1/sdk/bot-config/{resource_id}', methods: ['GET'], description: 'Get bot configuration' }
    ]
  },
  resaleOperations: {
    name: 'Resale Operations',
    description: 'Resale marketplace operations',
    basePath: 'api/v1/resale',
    endpoints: [
      { path: 'api/v1/resale/register-customer', methods: ['POST'], description: 'Register resale customer' },
      { path: 'api/v1/resale/{resource_id}/prices', methods: ['GET'], description: 'Get resale prices' },
      { path: 'api/v1/resale/{resource_id}/config', methods: ['GET'], description: 'Get resale configuration' }
    ]
  },
  publicStatistics: {
    name: 'Public Statistics',
    description: 'Public statistics and metrics',
    basePath: 'api/v1/statistics',
    endpoints: [
      { path: 'api/v1/statistics', methods: ['GET'], description: 'Get public statistics' }
    ]
  }
};

/**
 * Get all API groups for customer portal
 */
export const getCustomerPortalApiGroups = () => {
  return Object.keys(CUSTOMER_PORTAL_APIS).map(key => ({
    id: key,
    ...CUSTOMER_PORTAL_APIS[key]
  }));
};

/**
 * Get all API groups for public APIs
 */
export const getPublicApiGroups = () => {
  return Object.keys(PUBLIC_APIS).map(key => ({
    id: key,
    ...PUBLIC_APIS[key]
  }));
};

/**
 * Generate endpoint ID from path
 * Example: api/v1/resources/{resource_id}/config -> resources-resource-id-config
 * Example: api/bot-operations/create_session -> bot-operations-create-session
 */
export const generateEndpointId = (path) => {
  // Remove api/ prefix and the first path segment (customer_portal, bot-operations, etc.)
  let cleaned = path.replace(/^api\//, '');
  // Remove the first segment (customer_portal, bot-operations, etc.)
  cleaned = cleaned.replace(/^[^/]+\//, '');
  // Replace path parameters and slashes
  return cleaned
    .replace(/\{([^}]+)\}/g, '-$1')
    .replace(/\//g, '-')
    .toLowerCase()
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

/**
 * Get API group by ID
 */
export const getApiGroup = (apiType, groupId) => {
  const apis = apiType === 'customer' ? CUSTOMER_PORTAL_APIS : PUBLIC_APIS;
  return apis[groupId] ? { id: groupId, ...apis[groupId] } : null;
};

/**
 * Get all endpoints for a group
 */
export const getGroupEndpoints = (apiType, groupId) => {
  const group = getApiGroup(apiType, groupId);
  if (!group) return [];
  
  return group.endpoints.map(ep => ({
    ...ep,
    endpointId: generateEndpointId(ep.path)
  }));
};

/**
 * Get endpoint by group ID and endpoint ID
 */
export const getEndpointById = (apiType, groupId, endpointId) => {
  const endpoints = getGroupEndpoints(apiType, groupId);
  return endpoints.find(ep => ep.endpointId === endpointId) || null;
};

/**
 * Get API endpoint by ID (legacy - kept for backward compatibility)
 */
export const getApiEndpoint = (apiType, groupId, endpointPath) => {
  const apis = apiType === 'customer' ? CUSTOMER_PORTAL_APIS : PUBLIC_APIS;
  const group = apis[groupId];
  if (!group) return null;
  
  return group.endpoints.find(ep => ep.path === endpointPath);
};

